import { Dialog as DialogRoot } from "./Dialog";
import { Content, Paragraph } from "./Dialog.styled";
import { Title } from "./Title";
import { Actions } from "./Actions";

export { DialogRoot };

/**
 * Possible variants for the dialog:
 * - `blank` - A dialog without any content
 * - `icon` - A dialog with an icon
 * - `image` - A dialog with an image
 *
 * Dialog subcomponents:
 * - Title - The title of the dialog that get the icon from the dialog context
 * - Actions - The optional container for action buttons
 * - Content - The optional container for the content
 * - Paragraph - The wrapper for the text inside the `Content` component
 */
export const Dialog = {
  Title,
  Actions,
  Content,
  Paragraph,
};
